export const addGiftCard = {
  'add-gift-card.title': 'Add gift card',
};
